
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/sections/components/ChildBoxes/ChildBoxes.scss.css.virtualfile';
        module.exports = {"box":"_box_1daly_7","siteSegment":"_siteSegment_1daly_12"};